  <!-- <header class="navbar navbar-expand-lg navbar-dark fixed-top nga-navbar">
    <nav class="container p-0" aria-label="Main navigation"> 
      <a href="{{ENVIRONMENT.ssrUrl}}" class="navbar-brand m-r-0" alt="Accueil" aria-label="Gigsumo">
         <img src="../../../assets/icon/gigsumologo_bigface.png" class="img-ht" alt="Logo Gigsumo">
      </a>
 
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse"
        aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
 
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav mx-auto mrgn-auto">
          <li class="nav-item"  (mouseenter)="showDropdown()" (mouseleave)="hideDropdown()">
            <div class="custom-dropdown">
              <button class="dropdown-toggle-1" (click)="toggleDropdown()">
                <span class="dropdown-label">Solutions</span>
                <svg class="dropdown-arrow" width="16" height="16" viewBox="0 0 24 24"
                  [class.rotated]="isOpen">
                  <path fill="currentColor" d="M7 10l5 5 5-5z"/>
                </svg>
              </button>
              <div class="dropdown-menu" [class.show]="isOpen">
                <a *ngFor="let item of menuItems" 
                   [href]="item.route"
                   class="dropdown-item"
                   [class.active]="item.active"
                   (click)="selectItem(item)">
                  {{ item.label }}
                </a>
              </div>
            </div>
          </li>
          <li class="nav-item price-pos" mat-button>
            <a class="nav-link" aria-current="page" rel="noopener noreferrer" >
              Pricing
            </a>
          </li>
        </ul>


        <ul class="navbar-nav me-auto mr-r-0">
   
          <li class="nav-item">
            <a class="nav-link"  aria-current="page" rel="noopener noreferrer" 
                href="{{ENVIRONMENT.ssrUrl}}'jobs/job-details/'">
              Find Job
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link"  aria-current="page" rel="noopener noreferrer" 
             href="{{ENVIRONMENT.ssrUrl}}'jobs/candidate-details/'">
              Find Talent
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" aria-current="page" rel="noopener noreferrer" 
              href="{{ENVIRONMENT.ssrUrl}}'directory/all'">
              Companies
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" aria-current="page" rel="noopener noreferrer" href="{{ENVIRONMENT.ssrUrl}}web/book-a-demo.html">
              Book a Demo
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" aria-current="page" rel="noopener noreferrer" href="{{ENVIRONMENT.ssrUrl}}web/contact-sale.html">
              Contact Sales
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" aria-current="page" rel="noopener noreferrer" target="_blank"
              href="{{ENVIRONMENT.careOnlineWebUrl}}auth/login">
              Log in
            </a>
          </li>
          <li class="nav-item">
            <a class="btn-primary xtra-dec" aria-current="page" rel="noopener noreferrer" target="_blank"
              href="{{ENVIRONMENT.careOnlineWebUrl}}auth/signUp">
              Sign up for free
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </header> -->
  <header class="container-fluid navbar-678 navbar-expand-lg-678 navbar-dark-678 fixed-top-678 nga-navbar-678">
    <div class="container-678 p-0-678" style="max-width: none;">
      <div class="left-section-678">
        <!-- Logo -->
        <a id="header_logo" class="navbar-brand-678" href="/">
          <img src="assets/icon/gigsumologo_bigface.png" alt="Gigsumo Logo" class="logo-678">
        </a>
        
        <!-- Left Menu Items -->
        <!-- Solutions Dropdown -->
        <!-- <ul class="navbar-nav-678 left-menu-678">
          <li class="nav-item-678 dropdown-678">
            <a class="nav-link-678 dropdown-toggle-678" href="#" id="solutionsDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Solutions
            </a>
            <div class="dropdown-menu-678" aria-labelledby="solutionsDropdown">
              <a class="dropdown-item-678" href="{{ENVIRONMENT.ssrUrl}}web/recruiters.html">Recruiters</a>
              <a class="dropdown-item-678" href="{{ENVIRONMENT.ssrUrl}}web/bench-sales.html">Bench Sales</a>
              <a class="dropdown-item-678" href="{{ENVIRONMENT.ssrUrl}}web/job-seekers.html">Job Seekers</a>
              <a class="dropdown-item-678" href="{{ENVIRONMENT.ssrUrl}}web/benefits.html">Benefits</a>
            </div>
          </li>
          <li class="nav-item-678">
            <a class="nav-link-678" href="{{ENVIRONMENT.ssrUrl}}price">Pricing</a>
          </li>
        </ul> -->
      </div>
      
      <!-- Hamburger Toggle Button for Mobile -->
      <!-- <button class="navbar-toggler-678" type="button" data-bs-toggle="collapse" data-bs-target="#mainNavigation" 
              aria-controls="mainNavigation" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon-678"></span>
      </button> -->
      
      <!-- Right Side Navigation Links -->
      <!-- <div class="collapse-678 navbar-collapse-678" id="mainNavigation">
        <ul class="navbar-nav-678 right-menu-678">
          <li class="nav-item-678">
            <a class="nav-link-678" href="{{ENVIRONMENT.ssrUrl}}jobs/job-details/all">Find Job</a>
          </li>
          <li class="nav-item-678">
            <a class="nav-link-678" href="{{ENVIRONMENT.ssrUrl}}jobs/candidate-details/all">Find Talent</a>
          </li>
          <li class="nav-item-678">
            <a class="nav-link-678" href="{{ENVIRONMENT.ssrUrl}}directory/all">Companies</a>
          </li>
          <li class="nav-item-678">
            <a class="nav-link-678" href="{{ENVIRONMENT.ssrUrl}}web/book-a-demo.html">Book a Demo</a>
          </li>
          <li class="nav-item-678">
            <a class="nav-link-678" href="{{ENVIRONMENT.ssrUrl}}web/contact-sale.html">Contact Sales</a>
          </li>
          <li class="nav-item-678">
            <a class="nav-link-678 login-link-678" routerLink="/auth/login">Log in</a>
          </li>
        </ul>
        
        <div class="signup-container-678">
          <a  (click)="routePath()"  class="signup-btn-678">Sign up for free</a>
        </div>
      </div> -->
      <!-- Signup Button -->
    </div>
  </header>